
<igx-expansion-panel [(collapsed)]="section.collapsed" id="{{ section.sno }}"  class="expansion-panel-element">
	<!-- [(collapsed)]="section.collapsed" -->

	<igx-expansion-panel-header (click)="toggleShowDiv('divA')">
		<igx-expansion-panel-title>
				<div class="sec_name sec_name_main" [ngClass]="getTaskStatus(section)">
					<mat-icon class="play-arrow-icon">play_arrow</mat-icon>

					<span *ngIf="(section.type === 'video' || section.type === 'Video') && (section.videoType === 'standard video')" (click)="clickedVideoTopic(section, section.metadata.topics[0])" [ngClass]="activeVideo(section.sno)">
						{{ section.name }}
					</span>

					<span *ngIf="(section.type === 'video' || section.type === 'Video') && (!section.videoType)" [ngClass]="activeVideo(section.sno)">
						{{ section.name }}
					</span>

					<span class="quiz" *ngIf="section.type === 'quiz' || section.type === 'Quiz'" (click)="clickedSection(section)" [ngClass]="activeQuiz(section.sno)">
					<span class="quizSpan">{{ section.name }}</span>
					</span>

					<span *ngIf="section.type === 'download' || section.type === 'Download'" (click)="clickedSection(section)" [ngClass]="activeQuiz(section.sno)">
						<span>{{ section.name }}</span>
					</span>
					<!-- <span *ngIf="isSectionCompleted(section.sno, this.userProgress.sections)" class="completion-icon">&#10003;</span> -->
				</div>
		</igx-expansion-panel-title>
	</igx-expansion-panel-header>

	<igx-expansion-panel-body>
		<div class="unit_content_list_container" [@slideInOut]="animationState">
			<ul class="unit_content_list" *ngIf="(section.type === 'video' || section.type === 'Video') && !section.videoType">
				<li class="sec_name videotype" *ngFor="let topic of section.metadata?.topics; let i = index;" (click)="clickedVideoTopic(section, topic)" [ngClass]="activeVideo(topic.id)">
					<!-- <img src="{{ topic.thumbnailSource }}" class="topic-image" alt="Thumbnail"> -->
					<span class="topic-name videotypeSpan">{{ topic.name }}</span>
					<!-- <span *ngIf="userProgress && isTopicCompleted(section.sno, topic.id, this.userProgress.sections)" class="completion-icon">&#10003;</span> -->
				</li>
			</ul>

			<!-- <ul class="unit_content_list" *ngIf="section.type === 'download'">
				<li *ngFor="let document of section.metadata.documents; let i = index">
					Click to download <a (click)="downloadDocument(section.dfs, document.link)">{{ document.name }}</a>
				</li>
			</ul> -->

			<ul class="unit_content_list unit_content_list2" *ngIf="section.type === 'menu'">
				<li class="list_in_list" *ngFor="let subSection of section.menu; let i = index;">
					<app-programs-sidenav-igx [progressId]="progressId" [section]="subSection" (selectedSectionEvent)="clickedSection($event)" (videoLocationEvent)="clickedVideoTopicInChild($event)" [userProgress]="userProgress"></app-programs-sidenav-igx>
				</li>
			</ul>
		</div>
	</igx-expansion-panel-body>
</igx-expansion-panel>
